__turbopack_context__.v({
  "button": "HelpPill-module__KwnCXa__button",
  "container": "HelpPill-module__KwnCXa__container",
  "containerOpen": "HelpPill-module__KwnCXa__containerOpen",
  "linkContents": "HelpPill-module__KwnCXa__linkContents",
});
